import script from "./CatalogVisibilitySettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogVisibilitySettings.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogVisibilitySettings.vue?vue&type=style&index=0&id=da99dfa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da99dfa8"]])

export default __exports__